import { ArrowDropDown } from '@mui/icons-material';
import { BaseArrowDropDownProps } from './BaseArrowDropDown.types';

/**
 * This component exists to create a separation for mocking MUI
 * controls we import. This control renders the select drop down arrow icon
 * with any syling.
 *
 * @param className - {@link BaseArrowDropDownProps.className className} description.
 */
export const BaseArrowDropDown = ({
    className,
}: BaseArrowDropDownProps) => {
    return (
        <ArrowDropDown
            className={className}
        />
    );
};